import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faBars } from "@fortawesome/free-solid-svg-icons";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import { isMobile } from "react-device-detect";
import { IconButton, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { height } from "@fortawesome/free-solid-svg-icons/fa0";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/UserContext"; // adjust path
import { jwtDecode } from "jwt-decode";

const SidebarComponent = ({ logOut, toggleSidebar, isOpen }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const navigate = useNavigate();
  const { user, setUser } = useUser();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log(decoded, "Decoded");
        setFirstName(decoded.user?.first_name || "");
        setLastName(decoded.user?.last_name || "");
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);

  const renderSideBar = () => {
    return (
      <>
        {/* {isOpen && (
          <div
            className="sidebar-overlay"
            onClick={(e) => {
              // e.stopPropagation();
              toggleSidebar();
            }}
          />
        )} */}
        <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
          <div style={{ height: "auto" }}>
            <div className="header-sidebar">
              <img className="logo-hitfit" src={"img/hitfitlogo.jpg"} />
              <CloseIcon onClick={toggleSidebar} sx={{ color: "white" }} />
            </div>
            <div className="profile-section">
              <div className="avatar-placeholder"></div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span className="user-name">{firstName}</span>
                <span className="user-name">{lastName}</span>
              </div>
            </div>

            <ul className="menu">
              <div
                className="sidebar-icons-div"
                onClick={() => navigate("/edit_profile")}
              >
                <EditIcon
                  style={{ color: "white", height: "24px", width: "24px" }}
                />
                <li className="menu-item">Uredi profil</li>
              </div>
              {/* <div className="sidebar-icons-div">
                <CalendarMonthIcon
                  style={{ color: "white", height: "24px", width: "24px" }}
                />
                <li
                  className="menu-item"
                  onClick={() => (window.location.href = "/my-bookings")}
                >
                  Moji termini
                </li>
              </div> */}
              <div className="sidebar-icons-div">
                <LogoutIcon
                  style={{ color: "white", height: "24px", width: "24px" }}
                />
                <li className="menu-item" onClick={logOut}>
                  Odjavi se
                </li>
              </div>
            </ul>
          </div>
        </div>
      </>
    );
  };

  return renderSideBar();
};

export default SidebarComponent;
